export const mouse_key_map = {
  0: 'Mouse 0',
  1: 'Mouse 1',
  2: 'Mouse 2',
  3: 'Mouse 3',
  4: 'Mouse 4',
  8: 'BackSpace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Ctrl',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Esc',
  32: 'Space',
  33: 'Page Up',
  34: 'Page Down',
  35: 'End',
  36: 'Home',
  37: 'Left',
  38: 'Up',
  39: 'Right',
  40: 'Down',
  41: 'Select',
  42: 'Print',
  43: 'Execute',
  44: 'Print Screen',
  45: 'Insert',
  46: 'Delete',
  47: 'Help',
  48: '0',
  49: '1',
  50: '2',
  51: '3',
  52: '4',
  53: '5',
  54: '6',
  55: '7',
  56: '8',
  57: '9',
  65: 'A',
  66: 'B',
  67: 'C',
  68: 'D',
  69: 'E',
  70: 'F',
  71: 'G',
  72: 'H',
  73: 'I',
  74: 'J',
  75: 'K',
  76: 'L',
  77: 'M',
  78: 'N',
  79: 'O',
  80: 'P',
  81: 'Q',
  82: 'R',
  83: 'S',
  84: 'T',
  85: 'U',
  86: 'V',
  87: 'W',
  88: 'X',
  89: 'Y',
  90: 'Z',
  91: 'Left Windows',
  92: 'Right Windows',
  93: 'Applications',
  96: 'Numpad 0',
  97: 'Numpad 1',
  98: 'Numpad 2',
  99: 'Numpad 3',
  100: 'Numpad 4',
  101: 'Numpad 5',
  102: 'Numpad 6',
  103: 'Numpad 7',
  104: 'Numpad 8',
  105: 'Numpad 9',
  106: 'Multiply',
  107: 'Add',
  108: 'Separator',
  109: 'Subtract',
  110: 'Decimal',
  111: 'Divide',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  124: 'F13',
  125: 'F14',
  126: 'F15',
  127: 'F16',
  128: 'F17',
  129: 'F18',
  130: 'F19',
  131: 'F20',
  132: 'F21',
  133: 'F22',
  134: 'F23',
  135: 'F24',
  136: 'Num_Lock',
  137: 'Scroll_Lock',
  144: 'Num Lock',
  145: 'Scroll Lock',
  160: 'Left Shift',
  161: 'Right Shift',
  162: 'Left Ctrl',
  163: 'Right Ctrl',
  164: 'Left Alt',
  165: 'Right Alt',
  166: 'Browser Back',
  167: 'Browser Forward',
  168: 'Browser Refresh',
  169: 'Browser Stop',
  170: 'Browser Search',
  171: 'Browser Favorites',
  172: 'Browser Home',
  173: 'Volume Mute',
  174: 'Volume Down',
  175: 'Volume Up',
  176: 'Media Next Track',
  177: 'Media Previous Track',
  178: 'Media Stop',
  179: 'Media Play/Pause',
  180: 'Launch Mail',
  181: 'Launch Media Select',
  182: 'Launch Application 1',
  183: 'Launch Application 2',
  186: 'OEM 1',
  187: '=',
  188: ',',
  189: '-',
  190: '.',
  191: '/',
  192: '`',
  219: '[',
  220: '\\',
  221: ']',
  222: '\'',
  223: 'OEM 8',
  226: 'OEM 102',
  229: 'PROCESSKEY',
  231: 'PACKET',
  246: 'Attn',
  247: 'CRSEL',
  248: 'EXSEL',
  249: 'EREOF',
  250: 'Play',
  251: 'Zoom',
  252: 'Noname',
  253: 'PA1',
  254: 'Clear',
}
